<mat-dialog-content>
  <div class="message" [innerHTML]='safeHtml'></div>
  <div class="button-container">
    <button mat-raised-button (click)="onAnswer()" class="answer-btn">回答する</button>
  </div>
</mat-dialog-content>
